export function getEnv(name: string): unknown {
  return window?.configs?.[name] || process.env[name]
}
